import React, { useState, useEffect } from 'react';

export const ContadorCaracteres = ({ textoInicial = '', limite }) => {
    const [caracteresRestantes, setCaracteresRestantes] = useState(limite);

    useEffect(() => {

        setCaracteresRestantes(limite);
        if (textoInicial?.length > 0) {
            setCaracteresRestantes(limite - textoInicial?.length);
        }


    }, [textoInicial]);

    return (
        <span>
            Caracteres: {textoInicial?.length ?? 0}/{limite} (Restantes: {caracteresRestantes})
        </span>
    );
}
